import type { RecaptchaService } from '../../../utils/RecaptchaService';
import OnePageGivingMessaging from '../../OnePageGivingMessaging';
import { ErrorResponse } from '../../types';

const handle = async (response: ErrorResponse, recaptchaService: RecaptchaService) => {
  if (response.recaptchaValidated) {
    recaptchaService.reset();
  }

  OnePageGivingMessaging.addPageError(response.message);
};

export default {
  handle,
};
